import {
  DataHistogram24Regular,
  Payment24Regular,
  PeopleTeam24Regular,
  PlugConnected24Regular,
  Settings24Regular,
} from '@/components/Icon'

export const SETTINGS_NAV_GROUPS = [
  {
    id: 'account',
    label: 'Account',
    items: [
      { id: 'plan-usage', label: 'Plan & Usage', Icon: DataHistogram24Regular },
      { id: 'general', label: 'General', Icon: Settings24Regular },
      { id: 'users', label: 'Users', Icon: PeopleTeam24Regular },
      { id: 'billing', label: 'Billing', Icon: Payment24Regular },
      { id: 'connections', label: 'Connections', Icon: PlugConnected24Regular },
    ],
  },
]
